var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8710_295517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11C13.3813 11 14.5 9.88125 14.5 8.5C14.5 7.11875 13.3813 6 12 6C10.6187 6 9.5 7.11875 9.5 8.5C9.5 9.88125 10.6187 11 12 11ZM12 12.25C10.3312 12.25 7 13.0875 7 14.75V16H17V14.75C17 13.0875 13.6688 12.25 12 12.25Z",
    fill: "#495059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3208 9.20894C20.8361 7.21323 19.7087 5.42856 18.1089 4.12771C16.4813 2.80425 14.4573 2.05681 12.3556 2.00311C10.2538 1.94941 8.19389 2.5925 6.50011 3.8311C4.80632 5.0697 3.57498 6.83341 3 8.84448L3.72503 9.04949C4.25426 7.19845 5.38763 5.57506 6.94663 4.435C8.50565 3.29495 10.4017 2.70303 12.3362 2.75246C14.2707 2.80189 16.1337 3.48986 17.6318 4.70801C19.0766 5.88291 20.1029 7.48663 20.5624 9.28185L19.9585 9.33992L21.1502 11L22 9.14362L21.3208 9.20894Z",
    fill: "#495059",
    stroke: "#495059",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99536 14.5106L2.53466 13L2 15.0636L2.56283 14.9076C3.14268 16.9539 4.34853 18.7525 6.00151 20.0321C7.69669 21.3444 9.76579 22.0361 11.883 21.9985C14.0001 21.9609 16.0451 21.196 17.6956 19.8243C19.3462 18.4526 20.5087 16.552 21 14.4219L20.2615 14.2398C19.8093 16.2004 18.7394 17.9497 17.2201 19.2123C15.7008 20.4749 13.8186 21.1789 11.8699 21.2135C9.92122 21.2482 8.01672 20.6114 6.45642 19.4036C4.93971 18.2295 3.83197 16.5806 3.29634 14.7043L3.99536 14.5106Z",
    fill: "#495059",
    stroke: "#495059",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8710_295517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurn);
export default __webpack_public_path__ + "static/media/Churn.a54d800c.svg";
export { ForwardRef as ReactComponent };